import createIcon from '../../createIcon';

/**
 * @component @name Female
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNSA5QzE3LjUgNS45NiAxNS4wNCAzLjUgMTIgMy41QzguOTYgMy41IDYuNSA1Ljk2IDYuNSA5QzYuNSAxMS43IDguNDQgMTMuOTMgMTEgMTQuNFYxNi41SDlWMTguNUgxMVYyMC41SDEzVjE4LjVIMTVWMTYuNUgxM1YxNC40QzE1LjU2IDEzLjkzIDE3LjUgMTEuNyAxNy41IDlaTTguNSA5QzguNSA3LjA3IDEwLjA3IDUuNSAxMiA1LjVDMTMuOTMgNS41IDE1LjUgNy4wNyAxNS41IDlDMTUuNSAxMC45MyAxMy45MyAxMi41IDEyIDEyLjVDMTAuMDcgMTIuNSA4LjUgMTAuOTMgOC41IDlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Female = createIcon('Female', [
  [
    'path',
    {
      d: 'M17.5 9C17.5 5.96 15.04 3.5 12 3.5C8.96 3.5 6.5 5.96 6.5 9C6.5 11.7 8.44 13.93 11 14.4V16.5H9V18.5H11V20.5H13V18.5H15V16.5H13V14.4C15.56 13.93 17.5 11.7 17.5 9ZM8.5 9C8.5 7.07 10.07 5.5 12 5.5C13.93 5.5 15.5 7.07 15.5 9C15.5 10.93 13.93 12.5 12 12.5C10.07 12.5 8.5 10.93 8.5 9Z',
      key: '1hah51',
    },
  ],
]);

export default Female;
